import { api } from "@/services/api";
import { AddCategory, AddSubCategory, Category, EditCategory } from "@/types";

export class CategoryRepository {
  async findAll(): Promise<Category[]> {
    const response = await api.get("/v1/admin/categories");

    return response.data;
  }

  async add(categoryData: AddCategory): Promise<any> {
    const response = await api.post("/v1/admin/categories", categoryData);

    return response.data;
  }

  async update(id: string, data: EditCategory): Promise<any> {
    const response = await api.put(`/v1/admin/categories/${id}`, data);

    return response.data;
  }

  async addSubCategory(categoryId: string, data: AddSubCategory) {
    const response = await api.post(
      `/v1/admin/categories/${categoryId}/subcategories`,
      data,
    );

    return response.data;
  }

  async updateSubCategory(
    categoryId: string,
    subCategoryId: string,
    data: AddSubCategory,
  ) {
    const response = await api.put(
      `/v1/admin/categories/${categoryId}/subcategories/${subCategoryId}`,
      data,
    );

    return response.data;
  }

  async updateSubCategoryParentCategories(
    subCategoryId: string,
    data: { categoryIds: string[] },
  ) {
    const response = await api.put(
      `/v1/admin/categories/sub-categories/${subCategoryId}/categories`,
      data,
    );

    return response.data;
  }
}
